<template>
  <div>
    <div class="row justify-content-between mb-3">
      <div class="col-auto">
        <button @click="$router.push({ name: 'societies-index' })" class="btn btn-secondary">
          <i class="bi bi-arrow-left"></i> Retour
        </button>
      </div>
      <div class="col-auto">
        <button @click="editSociety" class="btn btn-primary">
          <i class="bi bi-pencil-square"></i> Modifier
        </button>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h5 class="mb-0">Détails de la société</h5>
      </div>
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-3">
            <strong>Référence:</strong> {{ society.reference }}
          </div>
          <div class="col-md-6">
            <strong>Nom complet:</strong> {{ society.fullName }}
          </div>
          <div class="col-md-3">
            <strong>Capitalisation:</strong> {{ formatNumber(society.capitalization) }}
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <strong>Adresse:</strong> {{ society.address || "—" }}
          </div>
          <div class="col-md-3">
            <strong>Ville:</strong> {{ society.city || "—" }}
          </div>
          <div class="col-md-3">
            <strong>Code postal:</strong> {{ society.zipCode || society.postalCode || "—" }}
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-3">
            <strong>Téléphone (1):</strong> {{ society.phoneA || society.phoneNumberA || "—" }}
          </div>
          <div class="col-md-3">
            <strong>Téléphone (2):</strong> {{ society.phoneNumberB || "—" }}
          </div>
          <div class="col-md-3">
            <strong>Fax:</strong> {{ society.fax || "—" }}
          </div>
          <div class="col-md-3">
            <strong>CNSS:</strong> {{ society.cnss || "—" }}
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-3">
            <strong>ICE:</strong> {{ society.ice || "—" }}
          </div>
          <div class="col-md-3">
            <strong>RC:</strong> {{ society.rc || "—" }}
          </div>
          <div class="col-md-3">
            <strong>IF:</strong> {{ society.if || "—" }}
          </div>
          <div class="col-md-3">
            <strong>TP:</strong> {{ society.tp || "—" }}
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <strong>Banque:</strong> {{ society.bank || "—" }}
          </div>
          <div class="col-md-6">
            <strong>RIB:</strong> {{ society.rib || "—" }}
          </div>
        </div>

        <div class="row mb-3" v-if="society.logo">
          <div class="col-md-12">
            <strong>Logo:</strong>
            <div class="mt-2">
              <img :src="$imageUrl(society.logo)" alt="Logo" style="max-width: 200px; max-height: 200px;" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("society", {
      society: "getSociety",
    }),
  },
  mounted() {
    this.$store.dispatch("society/show", this.$route.params.reference);
  },
  methods: {
    editSociety() {
      this.$router.push({
        name: "societies-edit",
        params: { reference: this.society.reference },
      });
    },
    formatNumber(number) {
      if (!number) return "—";
      return new Intl.NumberFormat("fr-FR", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(number);
    },
  },
};
</script>

